import Api from 'libs/api';

class AuthApi extends Api {
  constructor() {
    super('admin/auth');
    // super('auth');
  }

  signIn = (params) => {
    return this.buildQuery('post', params, 'signin');
  };

  sendPassword = (params) => {
    return this.buildQuery('post', params, 'send_reset_password');
  }
  
  resetPassword = (params) => {
    return this.buildQuery('post', params, 'reset_password');
  }

  signup = (params) => {
    return this.buildQuery('post', params, 'signup');
  }

  confirmEmail = (params) => {
    return this.buildQuery('post', params, 'confirmation_email');
  }

  confirmPhone = (params) => {
    return this.buildQuery('post', params, 'confirmation_phone');
  }

  changeEmail = (params) => {
    return this.buildQuery('post', params, 'change_email');
  }

  changePhone = (params) => {
    return this.buildQuery('post', params, 'change_phone');
  }

  resendCodePhone = (params) => {
    return this.buildQuery('post', params, 'resend_change_phone');
  }

  resendCodeEmail = (params) => {
    return this.buildQuery('post', params, 'resend_change_email');
  }

  finishPhone = (params) => {
    return this.buildQuery('post', params, 'finish_phone');
  }
}

export default AuthApi;
